export default {
  en: {
    title: 'Departments',
    subtitle: 'List of account departments for distribute/segment the calls.',
    columns: {
      name: 'Name',
      channels: 'Channels',
    },
    form: {
      name: {
        error: 'Please fill the name of department.',
        help: 'This is the name that customers see.',
      },
      channels: {
        error: '',
        help: 'Select where do you want this department show.',
      },
    },
  },
  es: {
    title: 'Departamentos',
    subtitle: 'Listado de departamentos para distribuir/segmentar las llamadas.',
    columns: {
      name: 'Nombre',
      channels: 'Canales',
    },
    form: {
      name: {
        error: 'Por favor ingrese el nombre del departamento.',
        help: 'Este el es el nombre que los clientes visualizan.',
      },
      channels: {
        error: '',
        help: 'Seleccione dónde quiere que se muestre este departamento.',
      },
    },
  },
};
